import { h } from 'preact';
import { useLayoutEffect, useRef, useState } from 'preact/hooks';
import { Card } from '../../../models';
import { FlippingCard } from '../FlippingCard';
import { CardBack } from '../FlippingCard/CardBack';
import { CardFront } from '../FlippingCard/CardFront';
import {
  Container,
  FlippingCardContainer,
  Stack,
} from './TripleQuadrupledCards.styles';

interface TripleQuadrupledCardsProps {
  cards: Card[];
  shouldFlip: boolean;
}

const TripleQuadrupledCards: ({
  cards,
  shouldFlip,
}: TripleQuadrupledCardsProps) => h.JSX.Element = ({ cards, shouldFlip }) => {
  const [cardHeight, setCardHeight] = useState<number | null>(null);
  const cardRef = useRef<HTMLDivElement>(null);
  useLayoutEffect(() => {
    const { height = null } = cardRef.current?.getBoundingClientRect();
    setCardHeight(height);
  }, [cardHeight, setCardHeight]);
  return (
    <Stack height={cardHeight} gap={16} align="center">
      {cards.map((card) => (
        <Container cardHeight={cardHeight} ref={cardRef} data-card-container>
          {shouldFlip ? (
            <FlippingCard
              card={card.data}
              flippingCardContainer={FlippingCardContainer}
              cardFront={CardFront}
              cardBack={CardBack}
            />
          ) : (
            <CardFront card={card.data} />
          )}
        </Container>
      ))}
    </Stack>
  );
};

export { TripleQuadrupledCards };
